import { representativeArticleListApi } from '@/entities/article';
import { PATH } from '@/shared/constants';
import { FeaturedContentCarouselSlide } from '@/shared/types';

export const getFeaturedContents = async (): Promise<
  FeaturedContentCarouselSlide[]
> => {
  const response = await representativeArticleListApi();

  const slides = response.data.map((item) => ({
    src: item.thumbnail_image,
    title: item.title,
    category: item.category[0].name,
    detailUrl: `${PATH.DETAIL}/${item.id}/`,
    categoryUrl: `${PATH.LIST}/${item.category[0].flag}`,
  }));

  return slides;
};
